/* ============================================================
   GENERATED by `npm run gen:durations` — DO NOT EDIT BY HAND.
   ------------------------------------------------------------
   Timeline length (ms) of every sequence-driven bump scene, derived
   from the scene's own sequence() (Σ shot.duration·1000 + tailMs):
   ads (broadcast schedule) and channel idents/stations (cover hold).
   Kept THREE-free so live.ts / the cover timer read it synchronously
   without the Three.js chunk. Regenerate after changing any scene's
   shots or tailMs.
   ============================================================ */
export const SCENE_DURATIONS_MS: Record<string, number> = {
  'ad-air': 9000,
  'ad-burger-too-much': 20267,
  'ad-cloth': 13033,
  'ad-communist': 9500,
  'ad-dad': 11083,
  'ad-gorp': 8283,
  'ad-ice': 10050,
  'ad-keynote-spoon': 12000,
  'ad-law': 10400,
  'ad-loud': 9167,
  'ad-marrow': 12950,
  'ad-milk2': 5400,
  'ad-moon': 11017,
  'ad-nod': 14867,
  'ad-oatorb': 9700,
  'ad-obelisk': 10650,
  'ad-petmortgage': 12483,
  'ad-pharma-vivendar': 11200,
  'ad-secondphone': 10650,
  'ad-sleep': 6300,
  'ad-truck-nowhere': 11400,
  'ad-vehicle': 8100,
  'ad-void': 8900,
  'ad-wrestling': 16717,
  'animal-program-card': 5050,
  'ident-adchannel': 6400,
  'ident-animal': 5000,
  'ident-important': 5250,
  'ident-night-desk': 6050,
  'ident-rickroll': 4400,
  'ident-sommelier': 6400,
  'ident-weekly': 6200,
  'important-program-card': 5200,
  'night-desk-program-card': 5200,
  'snow-pass': 800,
  'sommelier-program-card': 5420,
  'station-animal': 5150,
  'station-important': 4650,
  'station-night-desk': 5750,
  'station-sommelier': 5900,
  'station-weekly': 5300,
  'weekly-nowplaying': 4600,
}
